<template>  
  <div class="md-card md-theme-default">
    <md-card-header class="md-card-header-icon md-card-header-green list-header">
      <h4 class="title"><span class="heading" style="border-bottom: 0px">Tasks</span></h4>
      <a @click="addGroup" class="md-button md-primary md-sm add-group-btn">Add Group<md-icon class="md-small">control_point</md-icon></a>
    </md-card-header>
    <md-card-content>
      <div class="dynamicList-loading" v-show="false">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
      </div>
      <md-table
        :value="queriedData"
        :md-sort.sync="list.currentSort"
        :md-sort-order.sync="list.currentSortOrder"
        :md-sort-fn="customSort"
        class="paginated-table table-striped table-hover"
      >
        <!-- Group Task columns -->
        <template>
          <div class="md-layout move-right">
            <div class="md-layout-item md-xsmall-size-25 md-xsmall-size-25 md-size-25 md-medium-size-25 md-large-size-25 _breakWord md-form-label">Task</div>
            <div class="md-layout-item md-xsmall-size-10 md-xsmall-size-10 md-size-10 md-medium-size-10 md-large-size-10 _breakWord md-form-label">Status</div>
            <div class="md-layout-item md-xsmall-size-10 md-xsmall-size-10 md-size-10 md-medium-size-10 md-large-size-10 _breakWord md-form-label">CIO</div>
            <div class="md-layout-item md-xsmall-size-15 md-xsmall-size-15 md-size-15 md-medium-size-15 md-large-size-15 _breakWord md-form-label">Quick Note</div>
            <div class="md-layout-item md-xsmall-size-15 md-xsmall-size-15 md-size-15 md-medium-size-15 md-large-size-15 _breakWord md-form-label">Assignee</div>
            <div class="md-layout-item md-xsmall-size-15 md-small-size-15 md-size-15 md-medium-size-15 md-large-size-15 md-xlarge-size-15 _breakWord md-form-label">Due Date</div>
            <div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-size-10 md-medium-size-10 md-large-size-10 md-xlarge-size-10 _breakWord md-form-label">Actions</div>
          </div>
          <div class="_root" ref="draggableRoot">
            <!-- draggable component -->
            <draggable class="list-group" handle="._parentGroup__handle" v-bind="dragOptions" @end="dragend">
              <div class="_group _parentGroup" v-for="(_group, groupIndex) in groups" :key="groupIndex">

                <i class="_parentGroup__handle fa fa-order fa fa-align-justify"></i>

                <div class="md-layout-item md-size-100 group-layout" :data-parent="getItemAsJson(_group)">
                    <div class="list-group-item item" v-for="(element, elementIndex) in orderList(_group,'order')" :key="elementIndex">
                      <draggable :id="`element-${elementIndex}`" class="list-group" handle=".elementHandle" v-bind="dragOptions" draggable="._element" group="parentGroup" @end="dragend">
                        <div class="md-layout step-layout _element" :data-child="getItemAsJson(element)" v-if="element !== 0">
                          <div class="md-layout-item md-xsmall-size-25 md-small-size-25 md-size-25 md-medium-size-25 md-large-size-25 md-xlarge-size-25 _breakWord fieldText__fix" :title="element.subject">
                            <i class="fa fa-align-justify elementHandle"></i>
                            {{ element.subject }}
                          </div>
                          <div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-size-10 md-medium-size-10 md-large-size-10 md-xlarge-size-10 _breakWord">{{ element.status }}</div>
                          <div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-size-10 md-medium-size-10 md-large-size-10 md-xlarge-size-10 _breakWord">{{ element.isCompleteInOrder }}</div>
                          <div class="md-layout-item md-xsmall-size-15 md-small-size-15 md-size-15 md-medium-size-15 md-large-size-15 md-xlarge-size-15 _breakWord overFlow">{{ element.quickNote ? element.quickNote.substring(0, 30) : '' }}</div>
                          <div class="md-layout-item md-xsmall-size-15 md-small-size-15 md-size-15 md-medium-size-15 md-large-size-15 md-xlarge-size-15 _breakWord">{{ element.user ? (element.user.given_name + " " + element.user.family_name) : "" }}</div>
                          <div class="md-layout-item md-xsmall-size-15 md-small-size-15 md-size-15 md-medium-size-15 md-large-size-15 md-xlarge-size-15 _breakWord">{{ element.dateDue | formatDate }}</div>
                          <div class="md-layout-item md-xsmall-size-10 md-small-size-10 md-size-10 md-medium-size-10 md-large-size-10 md-xlarge-size-10 _breakWord">
                            <template v-for="(action) in list.itemActions">
                              <md-button
                                :key="action.icon"
                                :class="element.added? action.classAdded : action.class"
                                @click="callItemAction(action.click, element, elementIndex)"
                              >
                                <md-icon>{{element.added? action.iconAdded : action.icon}}</md-icon>
                              </md-button>
                            </template>
                          </div>
                        </div>
                      </draggable>
                    </div>
                    <div slot="footer" class="row list-group-item item" role="group">
                      <a v-if="!list.skipCardLayout" v-on:click="newRecord(groupIndex)" class="md-button md-primary md-sm" style="float:right; margin: 20px 12px;">Add Task<md-icon class="md-small">control_point</md-icon></a>
                    </div>
                </div>
              </div>
            </draggable>
          </div>
        </template>
      </md-table>
    </md-card-content>
    <md-dialog :md-active.sync="list.showRelatedDialog">
      <md-dialog-title>{{list.pageTitle}}</md-dialog-title>
      <md-dialog-content>
        <CustomCaseTemplateTaskDialog
          :filter="relateTasksListEsFilter"
          :list.sync="relateTasksList"
          :exclude="relateTasksListFilter"
          :relateRecordInput="{taskCaseId: $route.params.id, group: groupIndex, order: orderIndex}"
          @dialogChange="onDialogChange"
          @addTaskToCaseTemplate="onAddTaskToCaseTemplate"
          @taskCreated="onTaskCreated"
        ></CustomCaseTemplateTaskDialog>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-theme-default" @click="list.showRelatedDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import _ from "lodash";
  import { Pagination } from "@/components";
  import draggable from "vuedraggable";
  import { filter } from 'minimatch';
  import moment from 'moment'
  import jquery from 'jquery';

  import searchConfig from '@/searchConfig';

  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as mutations from '@/graphql/mutations';
  
  import CustomCaseTemplateTaskDialog from "@/components/DynamicForm/CustomCaseTemplateTaskDialog";

  export default {
    props: {
      list: {
        type: Object,
        required: false
      },
      params: {
        type: Object
      },
      relateRecordInput: {
        type: Object
      },
      relateRecordInputField: {
        type: String
      },
      initGroups: {
        type: Array
      },
      mode: {
        type: String
      },
    },
    components: {
      Pagination,
      draggable,
      CustomCaseTemplateTaskDialog
    },
    data() {
      return {
        relateTasksList: {
          hideListHeader: true,
          skipCardLayout: true,
          activeFlag: true,
          editPath: "tasks",
          pageTitle: "Add Task",
          pageIcon: "assignment_ind",
          listQueryId: "searchTaskStepsLists",
          responseFieldName: "searchTasks",
          createMutationId: "updateTask",
          deleteQueryId: "deleteTask",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "playlist_add",
              iconAdded: "check_circle",
              click: "addTaskToCaseTemplate"
            }
          ],
          columns: {
            subject: { label: "Subject", sortable: true },
            type: { label: "Type", sortable: true },
            priority: { label: "Priority", sortable: true },
            createdAt: { label: "createdAt", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            console.log(data);
            let result = [];
            let responseKey = 'searchTasks';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                result.push(item);
              })
            }
            console.log(result);
            return result;
          },
        },
        searchQuery: "",
        searchTimeout: null,
        isPromisePending: false,
        currentPage: 1,
        searchConfig: searchConfig,
        groups: [],
        orderedGroups: [],
        isBuildComplete: false,
        isDisabled: true,
        showDialog: false,
        activeAddTaskTab: 'tab-template',
        groupIndex: 0,
        orderIndex: 0,
        addToGroupIndex: 0,
      }
    },
    watch: {
      initGroups: {
        handler: function(newVal, oldVal) {
          console.log(newVal);
          if (newVal) {
            this.groups = newVal;
            setTimeout(() => {
              this.saveCaseTemplate();
            }, 100);
          }            
        },
        immediate: true        
      },   
    },
    computed: {
      relateTasksListEsFilter() {
        return [
          { match: { isTemplate: true } },
          {
            bool: {
              must_not: [
                { match: { hasWorkflow: true } },
              ]
            }
          }
        ]
      },
      taskCaseIdFilter: function () { return {"taskCaseId": {"eq": this.$route.params.id }}; },
      relateTasksListFilter: function () {
        let result = null;
        if (this.recordData) {
          let filters = [];
          filters.push({"match": {"taskCaseId": this.recordData.id}});

          if (filters.length) {
            result = {"must_not": filters};
          }
        }
        return result;
      },
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      },

      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.list.tableData;
        if (this.list.searchedData.length > 0) {
          this.$c.log("queriedData() using searchedData");
          result = this.list.searchedData;
        }
        return result.length? result.slice(this.from, this.to) : [];
      },
      to() {
        let highBound = this.from + this.list.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.list.pagination.perPage * (this.currentPage - 1);
      },
      total() {
        return this.list.searchedData.length > 0
          ? this.list.searchedData.length
          : this.list.tableData.length;
      },
    },
    methods: {
      orderList: function (list, orderBy='order') {
        return _.orderBy(list, orderBy);
      },
      onTaskCreated(task) {
        this.groups[this.addToGroupIndex].push(task);
        // Timeout add so that jquery can do dom update.
        setTimeout(() => {
          this.saveCaseTemplate();
          this.list.showRelatedDialog = false;
        }, 100);
      },
      onDialogChange(newValue) {
        this.list.showRelatedDialog = newValue;
      },
      getItemAsJson(element) {
        return JSON.stringify(element);
      },
      async saveCaseTemplate() {
        const $root = jquery(this.$refs.draggableRoot);
        const $parents = $root.find('[data-parent]');
        const data = [];
        const promiseArr = [];
        let groupIndex = 0;

        $parents.each((_index, _parent) => {
          const $currentParent = jquery(_parent);
          const $childs = $currentParent.find('[data-child]');
          var childItems = [];
          var parentData = {};
          try {
            parentData.data = JSON.parse($currentParent.data('parent'));
          } catch (e) {
            parentData.data = $currentParent.data('parent');
          }
          $childs.each((_childIndex, _child) => {
            let $currentChild = jquery(_child);
            let childData;
            try {
              childData = JSON.parse($currentChild.data('child'));
            } catch (e) {
              childData = $currentChild.data('child');
            }
            childItems.push(childData);
          });
          if (!childItems.length) {
            return;
          }
          groupIndex++;
          childItems = childItems.map(_child => {
            _child.group = groupIndex;
            return _child;
          });
          parentData.items = childItems;
          data.push(parentData);
        });
        this.$emit('tasksChanged', data);
      },
      buildGroups(payload) {
        const groups = [];
        this.list.tableData.map((_item) => {
          if (undefined === _item.group || null === _item.group) {
            return;
          }
          if (!groups[_item.group]) {
            groups[_item.group] = [];
          }
          groups[_item.group].push(_item);
        });
        this.groups = [];
        groups.map(_group => {
          if (_group.length) {
            this.groups.push(_group);
          }
        });
        if (!this.groups.length) {
          this.groups.push([]);
        }

        if (payload && this.groups[payload.groupId]) {
          this.groups[payload.groupId].push(payload.item);
          this.isBuildComplete = true;
        }
      },
      addGroup (){
        this.groups.push([]);
      },
      dragend() {
        this.isDisabled = false;
        // Timeout add so that jquery can do dom update.
        setTimeout(() => {
          this.saveCaseTemplate();
        }, 100);
      },
      callItemAction(funcName, item, itemIndex) {
        if (typeof this[funcName] === 'function') {
          return this[funcName](item, itemIndex);
        }
      },
      newRecord(groupIndex) {
        this.list.showRelatedDialog = true;
        this.addToGroupIndex = groupIndex;
      },
      customSort(value) {
        return value.sort((a, b) => {
          const sortBy = this.list.currentSort;
          let aSortBy = typeof a[sortBy] !== "undefined" && a[sortBy] !== null? a[sortBy] : "";
          let bSortBy = typeof b[sortBy] !== "undefined" && b[sortBy] !== null? b[sortBy] : "";
          if (this.list.currentSortOrder === "desc") {
            return aSortBy.localeCompare(bSortBy);
          }
          return bSortBy.localeCompare(aSortBy);
        });
      },
      handleRedirect(item) {
        this.$Session.tempRedirect = this.$route.path;
        //console.log(this.$Session, " --> session data")
        this.$router.push({ path: "/" + this.list.editPath + "/" + item.id});
      },
      handleDelete(item, itemIndex) {
        for( let i=0; i<this.groups.length; i++) {
          let indexToDelete = _.findIndex(this.groups[i], {
            id: item.id
          });
          if (indexToDelete != -1)
          {
            this.groups[i].splice(indexToDelete, 1);
          }
        } 
        setTimeout(() => {
          this.saveCaseTemplate();
        }, 100);
      },
      async onAddTaskToCaseTemplate(item) {
        let caseTemplateTaskTemplateData = {
          isTemplate: true,
          type: item.type,
          dateDue: item.dateDue,
          subject: item.subject,
          internal: this.$Session.isInternalGroupMember,
          priority: item.priority,
          status: item.status,
          isCompleteInOrder: item.isCompleteInOrder,
          dateCompleted: item.dateCompleted
        }
        if (item.user && item.user.id) 
          caseTemplateTaskTemplateData['taskUserId'] = item.user.id;
        
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        console.log(this.list);
        const updatedByFieldName = this.$reduce(this, 'list.updatedByTaskFieldName');
        if (true === this.list.hasUpdatedBy && updatedByFieldName) {
          caseTemplateTaskTemplateData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }
        
        let gqlRequest = graphqlOperation(mutations['createTask'], {input: caseTemplateTaskTemplateData});
        this.$c.log('gqlRequest', gqlRequest);
        const result = await API.graphql(gqlRequest)
        .then(result => {
          this.$c.log(result);
          this.groups[this.addToGroupIndex].push(result.data['createTask']);
          // Timeout add so that jquery can do dom update.
          setTimeout(() => {
            this.saveCaseTemplate();
          }, 100);

          let taskId = result.data['createTask'].id
          if(item.steps.items.length) {
            let stepsPromiseArr = [];
            for(let i=0; i<item.steps.items.length; i++) {
              let stepsInputData = {
                title: item.steps.items[i].title,
                description: item.steps.items[i].description,
                order: item.steps.items[i].order,
                status: item.steps.items[i].status,
                taskStepTaskId: taskId,
                isAvailable: item.steps.items[i].isAvailable,
              }
              
              /**
               * ATLAS-877 - Add Updatedby to all Models in the Schema
               * @see https://zeamster.atlassian.net/browse/ATLAS-877
               */
              const updatedByFieldName = this.$reduce(this, 'list.updatedByTaskStepFieldName');
              if (true === this.list.hasUpdatedBy && updatedByFieldName) {
                stepsInputData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
              }
              
              let gqlRequest = graphqlOperation(mutations['createTaskStep'], {input: stepsInputData});
              this.$c.log('gqlRequest create steps', gqlRequest);
              stepsPromiseArr.push(API.graphql(gqlRequest));
            }
            Promise.allSettled(stepsPromiseArr).then((resultStepsPromise) => {
              this.$c.log('Case Template Tasks and Steps Inserted Successfully');
            })
          }

        })
        .catch(error => {
          this.$c.log('error ', error);
        });
      },
    },
    filters: {
      formatDate: function(value) {
        if (value) {
          return moment(String(value)).format('MMM DD, YYYY')
        }
      }
    },
    async mounted() {
      if(this.mode == 'new')
        this.buildGroups(); 
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }

  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }

  .step-layout{
    border: 0.5px solid #ccc; 
    background-color: #f4fcfc;
    padding: 10px 0;
    max-height: 60px;
  }
  .md-layout-item.md-size-100.group-layout {
    border: 1px solid grey;
    padding: 0px;
    overflow: auto;
    margin-bottom: 3px;
  }
  .handle {
    float: left;
    padding-top: 5px;
    padding-bottom: 0px;
    margin-right: 10px;
  }
  .field-layout .md-field{
    padding-bottom: 8px;
    margin: 5px 0 0;
  }
  div .md-button:not([disabled]) {
    height: 32px;
    padding: 5px;
  }
  button.md-button.md-primary.md-sm.add-group-btn {
    float: left;
    margin: -30px 0px 0px 100px;
    padding: 2px 5px;
  }
  .md-button i {
    width: 24px;
    min-width: 24px;
    margin-left: 5px;
  }
  .md-layout-item .md-size-5{
    padding-top: 10px;
    padding-bottom: 26px;
  }
  h5.title {
    margin-bottom: 10px !important;
  }
  .align-input { 
    padding-top:9px; 
  }

  .md-card .md-card-content .md-form-label{
    text-align: left;
  }

  ._parentGroup {
    position: relative;
  }
  ._parentGroup__handle {
    position: absolute;
    top: 1rem;
    left: -2rem;
  }
  ._root {
    padding: 0 2rem;
  }
  .fieldText__fix {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    line-height: 1.5rem;
    max-height: 3rem;
  }
</style>
<style lang="scss">
  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    //display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  .main-panel{
    background-color: #ffffff;
  }
  .mdTab {
    width: 100%;
    padding-top: 35px;
    margin-bottom: 35px;
    border: 1px solid #c5c5c5;
    .md-tabs {
      .md-tabs-navigation {
        display: block;
        padding: 0;
        border-bottom: 1px solid #c5c5c5;
        box-shadow: none;
        .md-button {
          .md-tabs.md-theme-default .md-tabs-indicator {
            background-color: #2196f3 !important;
          }
        }
      }
      .md-tabs-indicator {
        display: block;
      }
      .md-tab {
        padding: 0.5rem;
      }
    }
  }

  .mdTabs {
    width: 100%;
    padding-top: 35px;
    margin-bottom: 35px;
    border: 1px solid #c5c5c5;
    .md-tabs {
      display: block;
      .md-tabs-navigation {
        display: block;
        padding: 0;
        border-bottom: 1px solid #c5c5c5;
        box-shadow: none;
        .md-button {
          .md-tabs.md-theme-default .md-tabs-indicator {
            background-color: #2196f3 !important;
          }
        }
      }
      .md-tabs-indicator {
        display: block;
      }
      .md-tab {
        padding: 0.5rem;
        display: block;
      }
    }
  }
  .mdTabs .md-tabs-container {
    transform: translate3d(0, 0, 0) !important;
  }

  .mdTabs .md-tabs .md-tab {
    display: none;

    &._isActive {
      display: block;
    }
  }
  
  .overFlow {
    overflow-wrap: break-word;
  }

  .move-right {
    padding: 0 2rem;
  }

</style>

